import { createStore } from './config';

/**
 * State for storing user information during onboarding flow.
 * This data is collected in the UserInformationStep and used
 * when creating/updating the user in OrganizationSetupStep.
 */
interface IOnboardingState {
  firstName: string;
  lastName: string;
  // TODO: Uncomment this once BE supports updating profile picture
  // profilePicture: File | null;
  setUserInfo: (info: {
    firstName: string;
    lastName: string;
    // TODO: Uncomment this once BE supports updating profile picture
    // profilePicture: File | null;
  }) => void;
  reset: () => void;
}

const initialState = {
  firstName: '',
  lastName: '',
  // TODO: Uncomment this once BE supports updating profile picture
  // profilePicture: null as File | null,
};

export const useOnboardingStore = createStore<IOnboardingState>(
  'onboarding-store',
  (_, _get, api) => ({
    ...initialState,

    setUserInfo: info => {
      api.setState(
        {
          firstName: info.firstName,
          lastName: info.lastName,
          // TODO: Uncomment this once BE supports updating profile picture
          // profilePicture: info.profilePicture,
        },
        false,
        { type: 'onboarding/setUserInfo', info },
      );
    },

    reset: () => {
      api.setState(initialState, false, 'onboarding/reset');
    },
  }),
);

/** Selector for first name */
export const selectFirstName = (state: IOnboardingState) => state.firstName;

/** Selector for last name */
export const selectLastName = (state: IOnboardingState) => state.lastName;

/** Selector for profile picture */
// TODO: Uncomment this once BE supports updating profile picture
// export const selectProfilePicture = (state: IOnboardingState) =>
//   state.profilePicture;

/** Selector for setUserInfo action */
export const selectSetUserInfo = (state: IOnboardingState) => state.setUserInfo;

/** Selector for reset action */
export const selectResetOnboarding = (state: IOnboardingState) => state.reset;

/** Selector for full display name (firstName + lastName) */
export const selectDisplayName = (state: IOnboardingState) =>
  `${state.firstName} ${state.lastName}`.trim();
